<template>
  <div>
    <template v-if="showReturnBookConfirm">
      <p class="u-font-lg">{{ $t('return_book_confirm') }}</p>
      <p>
        <return-book-button :buttonText="$t('yes')" :returnUrl="returnUrl" class="button"></return-book-button>&nbsp;
        <button v-on:click="close" class="button">{{ $t('no') }}</button>
      </p>
    </template>
    <template v-else>
      <p class="u-font-lg">
        <strong>{{ $t('book_ended') }}</strong><br>
        {{ $t('book_ended_return_question') }}
      </p>
      <p>
        <button v-on:click="showReturnBookConfirm = true" class="button">{{ $t('yes') }}</button>&nbsp;
        <button v-on:click="close" class="button">{{ $t('no') }}</button>
      </p>
    </template>
  </div>
</template>

<script>
  import ReturnBookButton from './ReturnBookButton'
  export default {
    components: {
      ReturnBookButton
    },

    props: {
      returnUrl: {
        type: String,
        default: null
      }
    },

    data () {
      return {
        showReturnBookConfirm: false
      }
    },

    methods: {
      close () {
        this.$emit('close')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EndingModalContent.vue